<template>
  <div
    id="app-container"
    :class="[{'log-as-active': $store.getters['auth/isLoggedAs']}, {'maintenance-active': $store.getters['auth/inMaintenance']}]"
  >
    <AppLoggedAs v-if="$store.getters['auth/isLoggedAs']"/>
    <AppScopeInMaintenance v-if="$store.getters['auth/inMaintenance']"/>
    <b-container fluid="">
      <AppHeader/>
      <div class="app-container">

        <!-- Go back button -->
        <b-button
          v-if="![$getConst.routesNames.timesheets, $getConst.routesNames.administration.scopes, $getConst.routesNames.notAllowedPage, $getConst.routesNames.selectRole].includes($route.name)"
          @click.prevent="$router.go(-1)"  :key="$route.name"
          class="mt-3 ml-5 d-none d-md-block"
          :variant="backButtonVariant"
        >

          <i v-if="isFreelancer()" :class="$getConst.icons.arrow_left + ' fa-2x'"></i>
          <i v-else :class="$getConst.icons.chevron_left"></i>
        </b-button>

        <b-container class="py-3">
          <transition name="fade" mode="out-in">
            <router-view :key="$route.path"></router-view>
          </transition>
        </b-container>

      </div>
    </b-container>
    <AppFooter v-if="$store.getters['auth/role'] !== 'Freelancer'"/>
  </div>
</template>

<script>
  import AppHeader from "./AppHeader";
  import AppScopeInMaintenance from "./AppScopeInMaintenance";
  import AppFooter from "./AppFooter";
  import AppLoggedAs from "./AppLoggedAs";

  export default {
    name: "AppContainer",
    components: {AppLoggedAs, AppFooter, AppHeader, AppScopeInMaintenance},
    computed: {
      backButtonVariant() {
        return this.isFreelancer() ? 'outline' : 'outline-dark';
      }
    }
  }
</script>

<style scoped type="scss">
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
